import { Component, OnInit } from '@angular/core';
import { DocService, eTabs } from "../services/doc.service";
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import samples_docs from "../../assets/samples.json";

@Component({
	selector: 'overview-component',
	templateUrl: './overview.component.html',
	styleUrls: ['./overview.component.scss'],
	providers: [DocService]
})

export class OverviewComponent {
    public overview: string;

    constructor(
        private _http: HttpClient,
        private _docService: DocService, 
        private _activatedRoute: ActivatedRoute, 
        private _router: Router) { 
        this._http.get('assets/README.md', { responseType: 'text' }).subscribe(data => {
            this.overview = data;
        }); 
	}

	async ngOnInit() {
	}	
    
    gettingStartedCode(): string {
        return samples_docs['ixnetwork_restpy.samples.getting_started.py'];
    }

	navigate(link: string) {
		this._router.navigateByUrl(link);
	}

	goRestpyRepo() {
		window.open('https://github.com/OpenIxia/ixnetwork_restpy');
	}

	goRestpyPyPi() {
		window.open('https://pypi.org/project/ixnetwork-restpy');
	}

    goRestpyPyPiFiles() {
        window.open('https://pypi.org/project/ixnetwork-restpy/#files');
    }

    goRestpySourceZip() {
        window.open('https://github.com/OpenIxia/ixnetwork_restpy/archive/master.zip');
    }

    goOpenIxiaRestpy() {
		window.open('https://github.com/OpenIxia/IxNetwork/tree/master/RestPy');
	}
}
